import React, { useEffect, useState } from 'react';
import { Card, Button, Form, Spinner, Alert, Badge, Modal } from 'react-bootstrap';
import api from '../../services/api';

const GenreSettings = () => {
  const [genres, setGenres] = useState([]);
  const [textarea, setTextarea] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchGenres();
  }, []);

  const fetchGenres = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await api.get('/songs/settings/genre/list');
      const genreList = res.data.data || [];
      setGenres(genreList);
      setTextarea(genreList.join(','));
    } catch (err) {
      setError('Failed to load genres');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    setLoading(true);
    setMessage('');
    setError('');
    const genreArr = textarea.split(',').map(g => g.trim()).filter(Boolean);
    const formData = new FormData();
    genreArr.forEach((g, i) => formData.append(`genres[${i}]`, g));
    try {
      const res = await api.post('/songs/settings/genre/update', formData);
      setMessage(res.data.message || 'Updated!');
      if (res.data.success) {
        setGenres(genreArr);
        setShowModal(false);
      }
    } catch (err) {
      setError('Failed to update genres');
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = () => {
    setTextarea(genres.join(','));
    setShowModal(true);
    setMessage('');
    setError('');
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setMessage('');
    setError('');
  };

  return (
    <Card className="shadow-sm">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="mb-0">Genres</h2>
          <Button variant="primary" onClick={handleOpenModal} disabled={loading}>
            Update
          </Button>
        </div>
        {error && <Alert variant="danger" className="mb-3">{error}</Alert>}
        {message && <Alert variant="success" className="mb-3">{message}</Alert>}
        <div className="mb-3">
          {genres.length === 0 && <span className="text-muted">No genres found.</span>}
          {genres.map((genre, idx) => (
            <Badge key={genre + idx} bg="success" className="me-4 mb-2 p-2 text-dark">{genre}</Badge>
          ))}
        </div>
        <Modal show={showModal} onHide={handleCloseModal} centered scrollable fullscreen="sm-down">
          <Modal.Header closeButton>
            <Modal.Title>Edit Genres</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3" controlId="genre-textarea">
                <Form.Label>Genres (comma separated)</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={5}
                  value={textarea}
                  onChange={e => setTextarea(e.target.value)}
                  disabled={loading}
                  placeholder="e.g. Jazz,Pop,Ballad"
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal} disabled={loading}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSave} disabled={loading}>
              {loading ? <><Spinner animation="border" size="sm" className="me-2" />Saving...</> : 'Save'}
            </Button>
          </Modal.Footer>
        </Modal>
      </Card.Body>
    </Card>
  );
};

export default GenreSettings; 